export default __webpack_public_path__ + "static/media/Roboto-BoldItalic.60c1f67b.ttf";